import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { MagicwandFillIcon } from '@/icons';
import { IconButton, Tooltip } from '@/ui_v3';
import { useOpenAiBuilderChat } from '@/views/build/features/ai-builder-chat/hooks';
import { useAiBuilderChatPanelSelector } from '@/views/build/features/ai-builder-chat/store';
import { useEditMode } from '../../focus/useIsEditMode';
export const useAiGenerateTool = () => {
  const {
    t
  } = useTranslation(['build']);
  const {
    panelOpen
  } = useAiBuilderChatPanelSelector();
  const openAiBuilderChat = useOpenAiBuilderChat();
  const {
    onEditModeChange
  } = useEditMode();
  if (panelOpen) return null;
  return {
    icon: <MagicwandFillIcon size="md" fill={ICON_COLOR.default} />,
    label: String(t('build:build.ai.createQuiz')),
    onClick: () => {
      onEditModeChange(true);
      openAiBuilderChat({
        entry: 'chat',
        source: 'quiz_card'
      });
    }
  };
};
export const AiGenerateButton = ({
  disabled
}: {
  disabled?: boolean;
}) => {
  const {
    isMobile
  } = useViewport();
  const aiGenerateTool = useAiGenerateTool();
  if (!aiGenerateTool) return null;
  const {
    label,
    onClick
  } = aiGenerateTool;
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="AiGenerateButton" data-sentry-source-file="AiGenerateButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="AiGenerateButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="AiGenerateButton.tsx">
          <IconButton size="xs" variant="outlined" intent="neutral" className="hidden mobile-lg:flex" disabled={disabled} onMouseDown={event => {
          event.preventDefault();
          event.stopPropagation();
        }} onClick={onClick} data-sentry-element="IconButton" data-sentry-source-file="AiGenerateButton.tsx">
            <MagicwandFillIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="MagicwandFillIcon" data-sentry-source-file="AiGenerateButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="AiGenerateButton.tsx">{label}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};